import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PublicHome.module.css';

function PublicHome() {
    return (
        <div className={styles.public_container}>
            <h2>Armários Inteligentes</h2>

            <div className={styles.adminHighlightContainer}>
                <div className={styles.adminHighlightText}>
                    <p className={styles.destaque}>A GuardAí é a primeira empresa de armários inteligentes do Nordeste!</p>
                    <p>Com a sede em <strong>Fortaleza-CE</strong>, estamos prontos para te ajudar a receber suas encomendas de maneira prática, segura e cômoda.</p>
                </div>
            </div>
        </div>
    );
}

export default PublicHome;
